/* ===== Badge Component ===== */

import type { HTMLAttributes, ReactNode } from 'react'

export type BadgeVariant = 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info' | 'neutral'

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode
  variant?: BadgeVariant
  size?: 'sm' | 'md'
}

const variantMap: Record<BadgeVariant, string> = {
  primary: 'bg-primary-50 text-primary-700 border-primary-200 dark:bg-primary-500/15 dark:text-primary-200 dark:border-primary-500/30',
  secondary: 'bg-primary-100 text-primary-800 border-primary-300 dark:bg-primary-500/20 dark:text-primary-100 dark:border-primary-500/30',
  success: 'bg-success-50 text-success-700 border-success-200 dark:bg-success-500/15 dark:text-success-100 dark:border-success-500/30',
  warning: 'bg-warning-50 text-warning-700 border-warning-200 dark:bg-warning-500/15 dark:text-warning-100 dark:border-warning-500/30',
  danger: 'bg-danger-50 text-danger-700 border-danger-200 dark:bg-danger-500/15 dark:text-danger-100 dark:border-danger-500/30',
  info: 'bg-info-50 text-info-600 border-blue-200 dark:bg-info-500/15 dark:text-blue-100 dark:border-info-500/30',
  neutral: 'bg-neutral-100 text-neutral-700 border-neutral-200 dark:bg-neutral-800 dark:text-neutral-200 dark:border-neutral-700',
}

const sizeMap = {
  sm: 'px-2 py-0.5 text-xs font-semibold',
  md: 'px-2.5 py-1 text-xs font-bold',
}

export function Badge({ children, variant = 'neutral', size = 'sm', className = '', ...props }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-[10px] border ${variantMap[variant]} ${sizeMap[size]} ${className}`}
      {...props}
    >
      {children}
    </span>
  )
}
